import { Component, Inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  MatAutocomplete,
  MatAutocompleteTrigger,
  MatOption,
} from '@angular/material/autocomplete';

import { catchError, debounceTime, distinctUntilChanged, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { IAltDest } from 'src/app/core/types/interfaces/trip-elements.interface';
import { Config } from 'src/app/core/configs/config';

interface IOption {
  country_id: number;
  isAttraction: boolean;
  isMajorAirport: boolean;
  isRegion: boolean;
  label: string;
  val: number;
}

@Component({
    selector: 'app-change-destination-dialog',
    templateUrl: './change-destination-dialog.component.html',
    styleUrls: [
        './change-destination-dialog.component.scss',
        '../../../../../../styles/dialogs.scss',
    ],
    imports: [
        FormsModule,
        MatAutocomplete,
        ReactiveFormsModule,
        MatAutocompleteTrigger,
        MatOption,
    ]
})
export class ChangeDestinationDialogComponent {
  searchForm: FormControl<string> = new FormControl<string>('');
  filteredOptions: IOption[] = [];
  newDestination: IAltDest;
  selectedDestinationRadio: number = -1;

  private selectedCustomDestination: IAltDest;

  constructor(
    public dialogRef: MatDialogRef<ChangeDestinationDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { name: string; altDestinations: IAltDest[]; index: number },
    private readonly httpClient: HttpClient,
  ) {
    this.initSearchFieldListener();
  }

  submitBtnHandler(): void {
    this.dialogRef.close(this.newDestination);
  }

  selectedDestinationHandler(destination: IOption): void {
    this.newDestination = {
      id: destination.val,
      name: destination.label,
      countryName: destination.label,
      country_id: destination.country_id,
      cityName: destination.label,
      place_id: destination.val,
      coordinates: '0,0',
      type: 'dest',
    };
    this.selectedCustomDestination = { ...this.newDestination };
    this.selectedDestinationRadio = 1;
  }

  selectCustomDestination(): void {
    if (this.selectedCustomDestination) {
      this.newDestination = { ...this.selectedCustomDestination };
    }
  }

  private initSearchFieldListener(): void {
    this.searchForm.valueChanges
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap((value) =>
          value
            ? this.httpClient
                .get<
                  IOption[]
                >(`${Config.apiUrl}actions/autocomplete.php?cc=1&term=${value}`)
                .pipe(
                  catchError(() => {
                    console.error('Error fetching autocomplete data');
                    return of([]);
                  }),
                )
            : of([]),
        ),
      )
      .subscribe((options) => {
        this.filteredOptions = options;
      });
  }
}
